var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy",rawName:"v-lazy:backgroundImage",value:({
        src: _vm.url || '',
        loading: _vm.lazyload ? '' : (_vm.url || '')
    }),expression:"{\n        src: url || '',\n        loading: lazyload ? '' : (url || '')\n    }",arg:"backgroundImage"}],staticClass:"wg-image",class:{
        ['wg-shadow__' + _vm.finalBoxShadow]: _vm.finalBoxShadow,
        ['wg-gradient_' + _vm.realStyle.gradient]: _vm.realStyle.gradient,
        ['wg-background__none']: _vm.realStyle.backgroundColor === 'none',
        ['wg-bg-color__' + _vm.finalBackgroundColor]: _vm.finalBackgroundColor,
        ['wg-border__box']: _vm.realStyle.type,
        ['wg-border__radius-' + _vm.realStyle.type]: _vm.realStyle.type,
    },style:({
        width: _vm.imageWidth,
        minWidth: _vm.imageWidth,
        height: _vm.realStyle.type ? _vm.imageWidth : _vm.imageHeight,
        margin: _vm.finalMargin,
        padding: _vm.finalPadding,
        paddingBottom: _vm.realPaddingBottom,
        borderRadius: _vm.realBorderRadius,
        backgroundImage: _vm.lazyload ? '' : `url(${_vm.url || ''})`,
        backgroundSize: _vm.realStyle.backgroundSize ? _vm.realStyle.backgroundSize: 'cover'
    })},[_vm._t("default"),(_vm.realDot)?_c('div',{staticClass:"wg-text__reddot"},[(_vm.dotText)?_c('wg-text',{staticClass:"wg-text__reddot-text",attrs:{"text":_vm.dotText,"styleObject":{backgroundColor: 'red', fontSize: 12, lineHeight: 14, color: 'white', fontWeight: 'bold'}}}):_c('wg-text',{staticClass:"wg-text__reddot-dot",attrs:{"styleObject":{backgroundColor: 'red'}}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }